<script lang="ts" setup>
import { useObserversStore } from '@/store/observers/observers'

import HeaderBottomCategories from '@/components/Header/HeaderBottomCategories.vue'
import HeaderBottomLinks from '@/components/Header/HeaderBottomLinks.vue'

const { categoryListState } = storeToRefs(useObserversStore())
</script>

<template>
  <nav
    :class="[
      'header-bottom-menu',
      { 'header-bottom-menu--categories': categoryListState },
    ]"
  >
    <transition name="ui-fade">
      <header-bottom-categories v-if="categoryListState" />

      <header-bottom-links v-else />
    </transition>
  </nav>
</template>

<style lang="scss" scoped>
.header-bottom-menu {
  max-height: 48px;
  overflow: hidden;
  background-color: var(--ui-color-white);
  border: solid var(--ui-color-sandy-200);
  border-width: 1px 0 1px;
  transition: max-height 0.2s ease-in;

  &--categories {
    max-height: 64px;
  }
}
</style>
